import React, { useState, useEffect } from 'react';
import { useAuth } from './vmAuthenticate';
import { sendRequest, extractSuffixFromField } from './vmUtils';
import { lambdaURL } from '../config';
//import { Alert, AlertDescription } from '@/components/ui/alert';

export const VMAdminPanel = () => {
  const [users, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [deleteConfirm, setDeleteConfirm] = useState(null);
  //const [successMessage, setSuccessMessage] = useState('');
  const { user } = useAuth();

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const response = await sendRequest(lambdaURL, {
        command: "getAllUsers"
      });

      if (response.body) {
        const parsedBody = JSON.parse(response.body);
        if (Array.isArray(parsedBody)) {
          setUsers(parsedBody);
        }
      }
      setIsLoading(false);
    } catch (err) {
      setError("Failed to fetch users");
      setIsLoading(false);
    }
  };

/*
  const handleMigrateEmails = async () => {
    try {
      const response = await sendRequest(lambdaURL, {
        command: "noTopicsForAssemblies"
      });
      console.log("Created No Topics! Response: ", response);
    } catch (err) {
      setError("Failed to migrate emails");
    }
  };
*/

  const handleDeleteUser = async (userId) => {
    try {
      console.log("Trying to delete user: ", userId);
      const response = await sendRequest(lambdaURL, {
        command: "deleteUser",
        deleteUserId: userId
      });

      if (response.body) {
        //setSuccessMessage(`User ${userId} deleted successfully`);
        setUsers(users.filter(user => user.userId !== userId));
        //setTimeout(() => setSuccessMessage(''), 3000);
      }
    } catch (err) {
      setError("Failed to delete user");
    }
    setDeleteConfirm(null);
  };

  if (isLoading) {
    return <div className="p-4">Loading...</div>;
  }
/*  

        <Alert variant="destructive">
          <AlertDescription>
          You do not have permission to access this page.
          </AlertDescription>
        </Alert>

         {successMessage && (
          {successMessage}
        )}

*/
  if (!user?.isAdmin) {
    return (
      <div className="p-4">
            You do not have permission to access this page.
      </div>
    );
  }

  /*
            <button
              onClick={() => handleMigrateEmails()}
              className="bg-red-500 text-white px-2 py-1 rounded hover:bg-red-600"
            >
              Migrate No Topics
            </button>
            <p></p>
  */

  return (
    <div className="p-4 w-full">
      <div className="mb-4">
        <h2 className="text-2xl font-bold mb-4">Admin Panel</h2>

        {error && (
          {error}
        )}
      </div>

      <div className="overflow-x-auto">
        <table className="w-full border-collapse table-auto">
          <thead>
            <tr className="bg-gray-100">
              <th className="p-4 text-left border">User ID</th>
              <th className="p-4 text-left border">Created At</th>
              <th className="p-4 text-left border">Actions</th>
            </tr>
          </thead>
          <tbody>
            {users.map((user) => (
              <tr key={user.userId} className="border-b hover:bg-gray-50">
                <td className="p-4 border text-sm">{ user.PK.replace(`USER#`, '') }</td>
                <td className="p-4 border">
                  {new Date(extractSuffixFromField(user.SK,'CREATED')).toLocaleDateString('en-US', {
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric'
                  })}
                </td>
                <td className="p-2 border">
                  {deleteConfirm === user.PK ? (
                    <div className="flex gap-2">
                      <button
                        onClick={() => handleDeleteUser(user.PK.replace(`USER#`, ''))}
                        className="bg-red-500 text-white px-2 py-1 rounded hover:bg-red-600"
                      >
                        Confirm
                      </button>
                      <button
                        onClick={() => setDeleteConfirm(null)}
                        className="bg-gray-500 text-white px-2 py-1 rounded hover:bg-gray-600"
                      >
                        Cancel
                      </button>
                    </div>
                  ) : (
                    <button
                      onClick={() => setDeleteConfirm(user.PK)}
                      className="bg-red-500 text-white px-2 py-1 rounded hover:bg-red-600"
                    >
                      Delete
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

//export default VMAdminPanel;